<template>
  <div>
    <div class="coach-info">
      <div class="head">
        <img :src="formData.icon" />
      </div>
      <div class="info">
        <h1>{{formData.name}}
          <span>{{formData.mobile}}</span>
        </h1>
        <h2>
          <span>{{formData.certificationDesc}}</span>
        </h2>
        <h3>{{formData.specialty}}</h3>
      </div>
      <div class="buttons">
        <el-button @click="editClick" type="primary" size="small">编辑教练</el-button>
      </div>
    </div>
    <el-tabs :value="activeName" @tab-click="handleClick">
      <el-tab-pane v-for="item in tabs" :label="item.label" :name="item.name" :key="item.name">
      </el-tab-pane>
    </el-tabs>
    <router-view/>
  </div>
</template>
<script>
export default {
  data () {
    return {
      tabs: [
        { label: '课程列表', name: 'course' },
        { label: '会员列表', name: 'member' }
      ],
      formData: {
        id: undefined,
        name: '',
        mobile: '',
        sex: undefined,
        certification: '',
        specialty: '',
        icon: ''
      }
    }
  },
  created: function () {
    this.formData.id = this.$route.params.id
    if (this.formData.id) { this.fetchData() }
  },
  methods: {
    fetchData () {
      var that = this
      that.api.coach.get({ id: that.formData.id }).then(response => {
        if (response.data.success) {
          Object.assign(that.formData, response.data.result)
        }
      })
    },
    handleClick (tab, event) {
      this.$router.replace(tab.name)
    },
    editClick () {
      this.$router.push({ path: '../../edit', query: { id: this.formData.uid } })
    }
  },
  computed: {
    activeName () {
      for (let i = 0; i < this.tabs.length; i++) {
        let tab = this.tabs[i]
        if (this.$route.path.endsWith(tab.name)) { return tab.name }
      }
    }
  }
}
</script>

<style scoped>
.coach-info {
  height: 100px;
  background: white;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 20px;
}

.coach-info .head {
  float: left;
  width: 100px;
  height: 100px;
  text-align: center;
}

.coach-info .head img {
  float: left;
  width: 80px;
  height: 80px;
  border-radius: 40px;
  margin: 10px;
}

.coach-info .info {
  float: left;
  height: 100px;
}

.coach-info .info h1 {
  padding: 0;
  margin: 0;
  font-size: 18px;
  color: #333;
  line-height: 40px;
}

.coach-info .info h1 span {
  padding-left: 30px;
  font-size: 14px;
  font-weight: normal;
}

.coach-info .info h2 {
  padding: 0;
  margin: 0;
  font-size: 12px;
  color: #333;
  line-height: 20px;
  font-weight: normal;
}

.coach-info .info h2 span {
  background: #e4e4e4;
  border-radius: 5px;
  color: #969494;
  padding: 5px;
}

.coach-info .info h3 {
  padding: 0;
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 40px;
  font-weight: normal;
}

.coach-info .buttons {
  float: right;
  line-height: 100px;
}
</style>



// WEBPACK FOOTER //
// index.vue?6b7bcc3b